import { useEffect, useState } from "react";
import MarketingShell from "@/components/marketing/MarketingShell";
import { CourseCard } from "@/components/marketing/CourseCard";
import { http } from "@/lib/api";
import { useSeo, StructuredData } from "@/lib/seo";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  useSeo({
    title: "Course Catalog | Infant Sleep Consultant Near Me",
    description: "Browse the Infant Sleep Consultant Near Me course catalog: self-paced courses on infant sleep foundations, naps and daily rhythm, night wakings and settling, sleep regressions, and bedtime, early waking and the crib transition, developed by Andrea Hurley.",
    canonical: "/courses",
  });
  useEffect(() => { http.get("/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);

  return (
    <MarketingShell>
      {courses.length > 0 && <StructuredData data={{
        "@context": "https://schema.org", "@type": "ItemList",
        itemListElement: courses.map((c, i) => ({ "@type": "ListItem", position: i + 1, url: `https://infantsleepconsultantnearme.com/courses/${c.slug}`, name: `${c.code} ${c.title}` })),
      }} />}
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-12">
        <div className="eyebrow text-[#BDA677] mb-5">Academic Program · Infant Sleep Studies</div>
        <h1 className="font-academic text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#F5F2E9] tracking-tight max-w-4xl leading-[1.02]" data-testid="courses-title">Course Catalog</h1>
        <p className="text-[#B9C0C9] mt-6 max-w-2xl text-base sm:text-[17px] leading-relaxed">
          Self-paced courses on foundations, daytime sleep, night wakings, regressions and bedtime, developed by Andrea Hurley, Certified Pediatric Sleep Consultant. Each course pairs required readings from the Infant Sleep Library with optional further reading, so you can go deeper without being overwhelmed.
        </p>
        <div className="gold-rule mt-12" />
      </section>
      <section className="bg-[#F5F2E9]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="courses-grid">
          {courses.map((c) => <CourseCard key={c.slug} c={c} light />)}
        </div>
        <p className="max-w-7xl mx-auto px-5 sm:px-8 pb-16 text-[#647080] text-sm">
          <span className="eyebrow text-[#9C8556] block mb-2">Admissions &amp; Tuition</span>
          Student registration and the Sleep Observation Tracker are free. IS-101 is a self-paced course with $99 tuition. Tuition for each subject course appears on its course page. Tuition is per family, with up to two caregivers.
        </p>
      </section>
    </MarketingShell>
  );
}
